import * as React from "react"
import { Link } from "gatsby"

type NavItemProps = {
  to: string
  label: string
}

const NavItem = ({ to, label }: NavItemProps) => (
  <Link
    className="primary-nav-link"
    activeClassName="is-active"
    partiallyActive={to !== "/"}
    to={to}
  >
    {label}
  </Link>
)

const HeaderNav = () => {
  return (
    <nav aria-label="Primary navigation" className="primary-navigation">
      <NavItem to="/" label="home" />
      <NavItem to="/publications" label="publications" />
      <NavItem to="/software" label="software" />
      <NavItem to="/contact" label="contact" />
    </nav>
  )
}

export default HeaderNav
